import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function ArrowRight({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M19.7071 11.2929L13.7071 5.29291L12.2929 6.70712L16.5858 11H4V13H16.5858L12.2929 17.2929L13.7071 18.7071L19.7071 12.7071C20.0976 12.3166 20.0976 11.6834 19.7071 11.2929Z"
        fill={iconColor}
      />
    </Svg>
  );
}
